/** React Query key prefixes for operator/government foreclosure case lists. */
export const OPERATOR_FORECLOSURE_CASES_QUERY_KEY =
  "operator-foreclosure-cases";
export const GOVERNMENT_FORECLOSURE_CASES_QUERY_KEY =
  "government-foreclosure-cases";

/** Second key segment for chart queries sharing the list prefix. */
export const FORECLOSURE_CASE_CHART_QUERY_KEY_PART = "chart-data";

/** Second key segment for the per-jurisdiction review-status summary. */
export const FORECLOSURE_CASE_JURISDICTION_SUMMARY_QUERY_KEY_PART =
  "jurisdiction-summary";

export const FORECLOSURE_CASE_MAP_PINS_QUERY_KEY_PART = "map-pins";

export const FORECLOSURE_CASE_FILTER_VALUES_QUERY_KEY_PART = "filter-values";

/**
 * Second key segments that hold server-side aggregates rather than case rows.
 * Reviewing a case changes these counts, so they are invalidated together
 * while the row caches are patched in place.
 */
export const FORECLOSURE_CASE_AGGREGATE_QUERY_KEY_PARTS: readonly string[] = [
  FORECLOSURE_CASE_CHART_QUERY_KEY_PART,
  FORECLOSURE_CASE_JURISDICTION_SUMMARY_QUERY_KEY_PART,
  FORECLOSURE_CASE_MAP_PINS_QUERY_KEY_PART,
  FORECLOSURE_CASE_FILTER_VALUES_QUERY_KEY_PART,
];
